var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ViewBreakpoint } from '../../models/view-breakpoint.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { takeUntil, filter } from 'rxjs/operators';
import { AnimationService } from 'src/app/engine/animation.service';
import { ViewService } from '../../view.service';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
var ViewNavbarComponent = /** @class */ (function () {
    // ---------- Lifecycle Events ----------
    function ViewNavbarComponent(animationService, viewService, changeDetectorRef, layoutService) {
        this.animationService = animationService;
        this.viewService = viewService;
        this.changeDetectorRef = changeDetectorRef;
        this.layoutService = layoutService;
        // ---------- Class Variables ----------
        this.viewBreakpoint = ViewBreakpoint;
        this.isAnimated = false;
        this.isPaginated = false;
        this.showScrubber = false;
        this.ngUnsubscribe = new Subject();
        this.viewLayout = ViewLayout;
        this.nextChapterLabel = '';
        this.previousChapterLabel = '';
    }
    ViewNavbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.chapter$.pipe(filter(function (chapter) { return chapter != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (chapter) {
            _this.isAnimated = _this.animationService.isChapterAnimated(chapter);
            _this.changeDetectorRef.markForCheck();
        });
        this.chapterCount$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (count) {
            _this.isPaginated = count > 1;
            _this.changeDetectorRef.markForCheck();
        });
        this.breakpoint$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (breakpoint) {
            _this.showScrubber = breakpoint !== ViewBreakpoint.Small;
            _this.changeDetectorRef.markForCheck();
        });
        combineLatest(this.chapterIndex$, this.chapterCount$).pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (_a) {
            var _b = __read(_a, 2), index = _b[0], count = _b[1];
            var previous = index > 0 ? index : 1;
            var next = index + 2 > count ? count : index + 2;
            _this.nextChapterLabel = "Next Chapter (" + next + " of " + count + ")";
            _this.previousChapterLabel = "Previous Chapter (" + previous + " of " + count + ")";
            _this.changeDetectorRef.markForCheck();
        });
    };
    ViewNavbarComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    // ---------- Interactions ----------
    ViewNavbarComponent.prototype.handleNextChapter = function () {
        this.viewService.nextChapter();
    };
    ViewNavbarComponent.prototype.handlePreviousChapter = function () {
        this.viewService.previousChapter();
    };
    ViewNavbarComponent.prototype.isVisible = function (layout) {
        return this.layoutService.isLayoutVisible(layout);
    };
    __decorate([
        Select(ViewState.getBreakpoint),
        __metadata("design:type", Observable)
    ], ViewNavbarComponent.prototype, "breakpoint$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], ViewNavbarComponent.prototype, "chapter$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterIndex),
        __metadata("design:type", Observable)
    ], ViewNavbarComponent.prototype, "chapterIndex$", void 0);
    __decorate([
        Select(StoryChaptersState.getChapterCount),
        __metadata("design:type", Observable)
    ], ViewNavbarComponent.prototype, "chapterCount$", void 0);
    return ViewNavbarComponent;
}());
export { ViewNavbarComponent };
